import gql from 'graphql-tag';


export const queryAllAIAssistants = gql`query ent($aIQuestionType: String)  {
                getAIQuestions (aIQuestionType: $aIQuestionType) {
                        id
                        masterItemId
                        name
                        description
                        question
                        tenantId
                        matchAbsence
                        aiQuestionGroup{
                            id
                            name
                            generalGroup
                        }
                        aIQuestionType
                        active
                        logInteraction
                        automated
                        saveResult
                    }
         }`

export const queryGetAIAssistant = gql`query ent ($id: String) {
                getAIQuestion (id: $id) {
                        id
                        name
                        description
                        question
                        tenantId
                        version
                        masterItemId
                        selected
                        matchAbsence
                        aiQuestionGroup{
                            id
                            generalGroup
                        }
                        aIQuestionType
                        active
                        logInteraction
                        automated
                        saveResult
                        customField 
                    }
         }`

         export const queryTenantAiConfig = gql `query ent {
           getTenantAiConfig {
               customFormatingPrompt
          }   
         }`

         export const updateTenantAiConfig = gql `mutation ent($data: TenantAiConfInputType){
               saveTenantAiConfig(data: $data)
         }`